import { useEffect, useState } from "react";
import { IconButton, Button, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { generateColumnsDefaultConfiguration } from "../../../../components/dataGrid/columnHelpers";

const ResultadoPH = ({
    value,
    handleChangeList,
    readOnly = false
}) => {
    const [inputValue, setInputValue] = useState("");
    const [resultadosPH, setResultadosPH] = useState(value || []);

    useEffect(() => {
        handleChangeList('listResultadoPH', resultadosPH)
    }, [resultadosPH]);

    useEffect(() => {
        if (value) {
            setResultadosPH(value);
        }
    }, [value]);

    const handleChange = (_, newValue) => {
        // Solo números enteros >= 0
        if (/^\d*$/.test(newValue) && Number(newValue) >= 0) {
            setInputValue(newValue);
        }
    };

    const handleAgregar = () => {
        if (inputValue === "") return;

        setResultadosPH((prev) => [
            ...prev,
            {
                posicion: prev.length + 1,
                resultado: Number(inputValue),
            },
        ]);
        setInputValue("");
    };

    const handleEliminar = (posicion) => {
        setResultadosPH((prev) =>
            prev
                .filter((row) => row.posicion !== posicion)
                .map((row, idx) => ({
                    ...row,
                    posicion: idx + 1,
                }))
        );
    };

    const columns = [
        {
            headerName: '',
            field: "actions",
            width: 80,
            renderCell: (params) => (
                <IconButton onClick={() => handleEliminar(params.row.posicion)}>
                    <DeleteIcon />
                </IconButton>
            ),
        },
        {
            field: "posicion",
            headerName: "Posición",
            width: 100,
        },
        {
            field: "resultado",
            headerName: "Resultado PH",
            width: 170,
        },
    ];

    const configuratedColumns = generateColumnsDefaultConfiguration(columns);

    return (
        <Grid container spacing={2} >
            <Grid size='grow'>
                <RenderInputByTypeMobile
                    input={{
                        displayName: "Resultado PH",
                        name: "resultadoPH",
                        type: "int",
                        label: "Resultado PH",
                        min: 0,
                        diabled: readOnly
                    }}
                    value={inputValue}
                    handleChange={handleChange}
                />
            </Grid>
            <Grid size='grow'>
                <Button
                    variant="outlined"
                    onClick={handleAgregar}
                    disabled={inputValue === "" || readOnly}
                >
                    Agregar
                </Button>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <DataGridGenerico
                    columns={configuratedColumns}
                    rows={resultadosPH}
                    entityId="posicion"
                />
            </Grid>
        </Grid>
    );
};

export default ResultadoPH;